var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 38,
    viewBox: "0 0 47 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 27L23.5 19L15.5 27",
    stroke: "#0061FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 19V37",
    stroke: "#0061FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2799 31.779C42.2306 30.7155 43.7716 29.0328 44.6597 26.9962C45.5477 24.9597 45.7323 22.6855 45.1843 20.5324C44.6363 18.3793 43.3869 16.47 41.6333 15.1059C39.8796 13.7418 37.7216 13.0005 35.4999 12.999H32.9799C32.3745 10.6575 31.2462 8.48366 29.6798 6.64098C28.1134 4.79829 26.1496 3.33469 23.9361 2.36021C21.7226 1.38572 19.317 0.925709 16.9002 1.01476C14.4833 1.1038 12.1181 1.73959 9.98227 2.87432C7.84649 4.00905 5.99574 5.6132 4.56916 7.56616C3.14259 9.51911 2.1773 11.7701 1.74588 14.1498C1.31446 16.5295 1.42813 18.9761 2.07835 21.3055C2.72856 23.635 3.8984 25.7867 5.49992 27.599",
    stroke: "#0061FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 27L23.5 19L15.5 27",
    stroke: "#0061FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloudUpload.41fa411bf193639095f854d48ea0017c.svg";
export { ForwardRef as ReactComponent };